<div id="accept-wrapper">
  <div id="accept">
    <h3>{{ 'cookies.title' | translate }}</h3>

    <p>{{ 'cookies.text' | translate }}</p>

    <div class="actions">
      <app-button [label]="'cookies.accept' | translate" [severity]="'primary'" (clickEvent)="onCookiesAccepted()" cssClass="full-btn"></app-button>
      <app-button [label]="'cookies.learn_more' | translate" [severity]="'primary'" (clickEvent)="openLegalNotice()" cssClass="full-btn"></app-button>
    </div>
  </div>
</div>
